import { getAllDevelopers, UpdateDev , search , deleteDev, addDeveloper} from "@/api/developers";
import { ref } from "vue";



const state = {
    developers: ref({}),
    isLoading: ref(false),
    lists: ref([]),

};
const actions = {
    async fetchDeveloper({commit} , page){
        try{
            const response = await getAllDevelopers(page);
            commit('SET_DEVELOPERS' , response.data.developers)
        }catch(error){
            console.log(error)
        }
    },
    async updateDeveloper({commit} , developer){
        try{
            const response = await UpdateDev(developer);
            commit('UPDATE_developer' , developer)
        }catch(e){
            console.log(e)
        }
    },
    async searchDeveloper({commit} , data){
        try{
            const response = await search( data.value , data.page);
            commit('SET_DEVELOPERS' , response.data.developers);
        }catch(error){
            console.log(error)
        }
    },
    async deleteDeveloper({commit} , id){
        try{
            await deleteDev(id);
            commit('DELETE_DEVELOPER' , id);

        }catch(e){
            console.log(e);
        }
    },
    async addNewDeveloper({commit} , developer){
        try{
            const resDeveloper = await addDeveloper(developer);
            console.log(resDeveloper);
            commit('ADD_DEVELOPER' , resDeveloper.data.developers);
        }catch(error){
            console.log(error)
        }
    },
};
const mutations = {
    UPDATE_developer(state , updatedDeveloper){
        
        state.developers.data.map((developer, index) => {
            if (developer.id === updatedDeveloper.id) {
                state.developers.data[index] = updatedDeveloper;
            }
        });
    },

    DELETE_DEVELOPER(state , id){
        state.developers.data = state.developers.data.filter(developer => developer.id !== id);
    },

    SET_DEVELOPERS(state , developers){
        
        state.developers = developers;
        state.developers.data = state.developers.data.map(developer => ({
            ...developer,
            is_developer_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        }))
        
    },

    ADD_DEVELOPER(state , developer){
        state.developers.data.unshift({
            ...developer,
            is_developer_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        });
    }
};
const getters = {
    getDevelopers: (state) => state.developers,
    /* getUnits: (state) => state.units,
    getLists:(state) => state.lists, */
};


export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};